import { KhaoSatService } from "../services/khaosat.service";
const khaosat = {
    thiSinhId: "",
    ksTruong: "",
    thuTu: 1
}
var state = {
    truongdaihoc: [],
    khaosats: [
        {
            thiSinhId: "",
            ksTruongId: "",
            thuTu: 1
        }
    ]
}
var getters = {};

var mutations = {
    getKhaoSatTruong(state, data) {
        state.truongdaihoc = [...data];
    },
    themKhaoSat(state) {
        state.khaosats.push({ ...khaosat });
    },
    updateKhaoSatTruongId(state, { khaosat, stt }) {
        khaosat.thuTu = stt + 1;
        state.khaosats[stt] = { ...khaosat };
    },
    async deleteKhaoSat(state, index) {
        let ks = await [...state.khaosats];
        state.khaosats = [];
        state.khaosats = await ks.filter((value, ind) => {
            if (index !== ind) return value;
        });
    },
    getKhaoSats(state, data) {
        state.khaosats = [...data];
    },
    loadNew(state) {
        state.khaosats = [{ ...khaosat }];
    }
};

var actions = {
    getKhaoSatTruong({ commit }) {
        return KhaoSatService.getKhaoSatTruong().then((response) => {
            if (response.status === 200)
                commit("getKhaoSatTruong", response.data);
            return response;
        }).catch((error) => error.message)
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
